var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "1000px" } },
    [
      _c("Button", { staticClass: "sav-btn", on: { click: _vm.save } }, [
        _vm._v("确认"),
      ]),
      _vm._v(" "),
      _c("Button", { staticClass: "cancel-btn", on: { click: _vm.cancel } }, [
        _vm._v("取消"),
      ]),
      _vm._v(" "),
      _c("div"),
      _vm._v(" "),
      _c("iframe", {
        attrs: {
          src: _vm.mapUrl,
          width: "100%",
          height: "600px",
          frameborder: "0",
          allowfullscreen: "",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }